import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';

import { updateInfo } from '../actions/user';
import UserUtils from '../utils/UserUtils';
import APIClient from '../utils/APIClient';

import MenuList from '../menu/MenuList';
import LoginScreen from '../auth/LoginScreen';
import ProfileScreen from '../profile/ProfileScreen';
import UpdatePasswordScreen from '../profile/UpdatePasswordScreen';
import UpdatePromoCodeScreen from '../profile/UpdatePromoCodeScreen';
import OrderListScreen from '../order/OrderListScreen';
import OrderScreen from '../order/OrderScreen';
import AgencyListScreen from '../agency/AgencyListScreen';
import AgencyScreen from '../agency/AgencyScreen';
import NotificationListScreen from '../notification/NotificationListScreen';
import PartnerListScreen from '../partner/PartnerListScreen';
import PartnerScreen from '../partner/PartnerScreen';
import CreateAgencyScreen from '../partner/CreateAgencyScreen';
import SellerScreen from '../seller/SellerScreen';
import SellerPriceScreen from '../seller/SellerPriceScreen';
import PaymentScreen from '../payment/PaymentScreen';
import PrepayScreen from '../order/PrepayScreen';
import SellerOrderListScreen from '../seller/SellerOrderListScreen';
import EditOrderScreen from '../order/EditOrderScreen';
import ConfirmedOrderListScreen from '../order/ConfirmedOrderListScreen';
import UserManager from '../utils/UserManager';

class MainIndex extends Component {

  constructor (props) {
    super(props);

    const {credential, user} = this.props;
    UserManager.getInstance().initialize(user);
    APIClient.updateCredential(credential);
  }

  componentDidMount () {
    this._updateUserInfo();
  }

  componentWillUnmount () {
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.user) {
      UserManager.getInstance().updateUser(nextProps.user);
    }
    if (nextProps.credential) {
      APIClient.updateCredential(nextProps.credential);
    }
  }

  _updateUserInfo = async () => {
    if (!UserManager.getInstance().isSignedIn()) {
      return;
    }

    for (let i = 0; i < 3; i++) {
      const {response, error} = await APIClient.GET('/user');
      /*if (response) {
        console.log(response);
      }
      if (error) {
        console.error(error);
      }*/

      if (response && response.response) {
        this.props.updateInfo(response.response);
        break;
      }
    }
  };

  _handleClickMenu = (item) => {
    this._router.history.push(item.path);
  };

  render () {
    const {user} = this.props;
    const isSignedIn = UserUtils.isSignedIn(user);
    const isAdmin = UserUtils.isAdmin(user);
    if (!isSignedIn) {
      return <LoginScreen/>;
    }

    return (
      <View
        style={styles.container}>
        <MenuList
          onClick={this._handleClickMenu}/>
        <View
          style={styles.content}>
          <Router
            ref={ref => this._router = ref}>
            <Switch>
              <Route exact path='/' component={OrderListScreen}/>
              <Route path='/order/:id' component={OrderScreen}/>
              <Route exact path='/agencies' component={AgencyListScreen}/>
              <Route path='/agencies/:id' component={AgencyListScreen}/>
              <Route path='/agency/:id' component={AgencyScreen}/>
              <Route path='/notifications' component={NotificationListScreen}/>
              <Route path='/me' component={ProfileScreen}/>
              <Route path='/password' component={UpdatePasswordScreen}/>
              <Route path='/promo-code' component={UpdatePromoCodeScreen}/>
              <Route path='/partners' component={PartnerListScreen}/>
              <Route path='/partner/:id' component={PartnerScreen}/>
              <Route path='/create-agency' component={CreateAgencyScreen}/>
              <Route path='/seller/price/:id' component={SellerPriceScreen}/>
              <Route path='/seller/:id' component={SellerScreen}/>
              <Route path='/payment' component={PaymentScreen}/>
              <Route path='/prepay' component={PrepayScreen}/>
              <Route path='/orders/seller/:id'
                     component={SellerOrderListScreen}/>
              <Route path='/edit-order/:id' component={EditOrderScreen}/>
              <Route path='/orders/confirmed'
                     component={ConfirmedOrderListScreen}/>
            </Switch>
          </Router>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    display: 'flex',
    backgroundColor: '#f6efdb',
  },
  content: {
    flex: 1,
    backgroundColor: '#ffffff',
  },
});

const mapStateToProps = (state) => {
  return {
    credential: state.user.credential,
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateInfo: (info) => dispatch(updateInfo(info)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainIndex);



// WEBPACK FOOTER //
// ./src/main/MainIndex.web.js